import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { eventShape } from 'app/shapes/events';
import { selectLocationEntities, selectPlaceEntities } from 'app/selectors/EntitiesSelector';
import EventDateStamp from 'app/components/events/EventDateStamp';
import EventDateTime from 'app/components/shared/EventDateTime';
import EventLocation from 'app/components/events/EventLocation';

export default function EventDetails({ event, eventSeries }) {
  const locations = useSelector(selectLocationEntities);
  const places = useSelector(selectPlaceEntities);

  const definition = event.getIn(['definition']);
  const isVirtual = definition.get('isVirtual');
  const location = definition.get('branchLocationId')
    ? locations.get(definition.get('branchLocationId'))
    : places.get(definition.get('nonBranchLocationId'));

  const registrationInfo = definition.get('registrationInfo');
  const scope = registrationInfo.get('scope');
  const firstEventKey = eventSeries.getIn(['eventKeys', 0]).toString();
  const [date] = firstEventKey?.split('T');
  const seriesStartDate = scope && moment(date).format('LL');
  const seriesStartDay = scope && moment(eventSeries.getIn(['eventKeys', 0])).format('dddd');

  function renderEventInfo() {
    if (scope) {
      return (
        <FormattedMessage
          id="events.registration.series.dates.message"
          values={{ seriesStartDay, seriesStartDate }}
          defaultMessage={`Series begins ${seriesStartDay}, ${seriesStartDate}.`}
        />
      );
    }
    return (
      <EventDateTime
        start={event.getIn(['definition', 'start'])}
        end={event.getIn(['definition', 'end'])}
        includeYear
      />
    );
  }

  return (
    <div className="event-details">
      <EventDateStamp event={event} />
      <div className="event-title">
        <div className="section-title">{event.getIn(['definition', 'title'])}</div>
        {renderEventInfo()}
        <EventLocation location={location} isVirtual={isVirtual} />
      </div>
    </div>
  );
}

EventDetails.propTypes = {
  event: eventShape.isRequired,
  eventSeries: ImmutablePropTypes.map.isRequired
};
